import { deriveBmsSocPercentFromCapacities, normalizeBmsRawInput, num } from "./bmsRawData";

export type BatteryHealthLevel = "good" | "warn" | "bad" | "unknown";

/** Пороги ΔV між мін і макс коміркою, В (типовий дисбаланс 10S паку) */
const DELTA_GOOD_MAX_V = 0.01;
const DELTA_WARN_MAX_V = 0.025;

export function getBmsSocPercent(raw: unknown): number | undefined {
  const obj = normalizeBmsRawInput(raw);
  if (!obj) {
    return undefined;
  }
  return deriveBmsSocPercentFromCapacities(obj);
}

/** Загальна напруга пакета з BMS (`voltage` у payload), В. */
export function getBmsPackVoltageVolts(raw: unknown): number | undefined {
  const obj = normalizeBmsRawInput(raw);
  if (!obj) {
    return undefined;
  }
  const v = num(obj.voltage);
  return v !== undefined && Number.isFinite(v) ? v : undefined;
}

/** Струм пакета з BMS (`current` у payload), А (відʼємний — заряд). */
export function getBmsCurrentAmps(raw: unknown): number | undefined {
  const obj = normalizeBmsRawInput(raw);
  if (!obj) {
    return undefined;
  }
  const a = num(obj.current);
  return a !== undefined && Number.isFinite(a) ? a : undefined;
}

export function getEffectiveDeltaVoltage(battery: {
  deltaVoltage?: number | null;
  bmsLastRawData?: unknown;
}): number | null {
  if (typeof battery.deltaVoltage === "number" && Number.isFinite(battery.deltaVoltage)) {
    return battery.deltaVoltage;
  }
  const obj = normalizeBmsRawInput(battery.bmsLastRawData);
  if (!obj) {
    return null;
  }
  const fromBms = num(obj.delta_voltage);
  return fromBms !== undefined ? fromBms : null;
}

export function getBatteryHealthLevel(deltaVolts: number | null): BatteryHealthLevel {
  if (deltaVolts === null || !Number.isFinite(deltaVolts) || deltaVolts < 0) {
    return "unknown";
  }
  if (deltaVolts <= DELTA_GOOD_MAX_V) {
    return "good";
  }
  if (deltaVolts <= DELTA_WARN_MAX_V) {
    return "warn";
  }
  return "bad";
}

export function batteryHealthTitle(level: BatteryHealthLevel, deltaVolts: number | null): string {
  if (level === "unknown") {
    return "Немає даних про різницю напруги (ΔV)";
  }
  const mv = deltaVolts !== null ? (deltaVolts * 1000).toFixed(0) : "";
  if (level === "good") {
    return `Норма: ΔV ${mv} мВ (≤ ${DELTA_GOOD_MAX_V * 1000} мВ)`;
  }
  if (level === "warn") {
    return `Підвищена різниця: ΔV ${mv} мВ (${DELTA_GOOD_MAX_V * 1000}–${DELTA_WARN_MAX_V * 1000} мВ)`;
  }
  return `Критична різниця: ΔV ${mv} мВ (>${DELTA_WARN_MAX_V * 1000} мВ) — потрібна перевірка`;
}
